import template from './progress-bar.html';
import controller from './progress-bar.controller';
import './progress-bar.css';

const ProgressBarComponent = {
    template,
    controller,
    bindings: {
        unit: '<',
        value: '<',
        total: '<',
        active: '<'
    },
};

export default ProgressBarComponent;



// WEBPACK FOOTER //
// ./components/progress-bar/progress-bar.component.js